class ClientError extends Error {}

export { ClientError };
